// 遥感商城所属接口

import * as config from "./config";
// 入驻商家提交
export const NewsupplierSave = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/supplier/save';
// 商家修改
export const editSupplierupdate = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/supplier/update';
// 商品排行榜
export const GoodsRankList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/rank/';
// 遥感商城-固定数据商品获取【6】
export const GoodsFixedNum = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/v2/api/goods/list/';
// 遥感商城-商品销售量统计
export const GoodsCount = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/sale/count';
// 遥感商城-商品板块分类
export const GoodsModuleClass = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/productPlate/list';
// 遥感商城-商家统计信息
export const shopsStatic = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/statistical';
// 遥感商城-添加到购物车
export const shoppingCartaddItem = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/shoppingCart/v2/addItem';
// 遥感商城-创建订单
export const shoppingCartAddOrder = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/addOrder';
// 遥感商城-根据商品id查询商家信息
export const IDsupplierGet = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/supplier/get/';
// 根据商品id查询店铺信息
export const IDshopGet = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/shop/get';
// 添加关注店铺
export const focusSaveAdd = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/focus/save';
// 取消关注店铺
export const focusSaveDel = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/focus/deleteByShopId';
// 根据商品id 相关推荐列表
export const goodsRecommend = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/recommend/list/';
// 添加浏览记录
export const bowerSaveAdd = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/bower/save';
// 是否收藏
export const collectwhether = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/collect/whether';
// 添加收藏商品
export const collectadd = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/collect/add';
// 取消收藏商品
export const collectdel = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/collect/deleteByGoodsId';
// 需求发布
export const demandFB = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/demand';
// 商家商品分页列表
export const getSupplierGoods = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/supplier/page';
//交易大厅交易量相关统计数据
export const getStatisticalData = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/trade/count';
// 遥感商城-根据商家id查询商家信息
export const IDsolutionSupplierGet = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/solution/supplier/get/';
// 根据店铺id查询店铺信息
export const IDsolutionshopGet = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/solution/shop/get';
//商品需求分页列表
export const CommodityDemandList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/demand/page';
//获取软件平台商品分类
export const ClassificationOfGoods = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/software/category/list';

// 进入遥感商城获取 - 数据产品、影像数据、软件产品等商品分页数据
export const requestGoodsPageDatas = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/page';
// 获取行业解决方案数据
export const requestSolutionPageDatas = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/solution/page';
// 获取店铺的分页数据
export const requestShopsPageDatas = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/shop/page';
// 获取商品的详情数据 + goodsId
export const requestProductDetail = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/get/';
// 获取商品的收藏、评论和购买 + goodsId
export const requestProductCounts = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/basic/count/';
// 店铺 - 全部商品部分 (非商户)
export const requestShopAllProduct = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/shop/page'